import authService from '../api-authorization/AuthorizeService'

export default class ServicesApi {
  static async getHeaders() {
    const token = await authService.getAccessToken();
    return !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' };
  }
}